import { z } from 'zod';
import { paginationSchema } from './common.js';
export const adminCreateSchema = z.object({
    email: z.string().email().max(255),
    password: z.string().min(12).max(200),
});
export const adminUpdateSchema = z
    .object({
    email: z.string().email().max(255).optional(),
    password: z.string().min(12).max(200).optional(),
})
    .refine((d) => d.email !== undefined || d.password !== undefined, {
    message: 'En az bir alan güncellenmeli',
});
export const adminListQuerySchema = paginationSchema;
